import '../chart_view.js.coffee'
class Monitoring.Views.Charts.LineChartView extends Monitoring.Views.Charts.ChartView

  template: JST['backbone/templates/monitoring/charts/empty_chart']

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (data = {}, title) =>
    @$el.html(@template())
    @chart = new Highcharts.Chart(@chartOptions(data, title))

  chartOptions:(data, title) =>
    options = {
      chart:
        type: 'line'
        backgroundColor: '#f2f2f2'
        renderTo: @$el.find('#container')[0]
        width: 800
      title:
        text: title
      xAxis:[{
        type: 'datetime'
        labels:
          rotation: -90
        tickInterval: @tick_interval()
        dateTimeLabelFormats:
            day: '%Y-%m-%d'
      }]
      plotOptions:
        area:
          stacking: true
      tooltip:
        shared: true
      series: data
    }


  tick_interval:() =>
    7*24*60*60*1000
